import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface TagItemProps {
  item: string;
  index: number;
  onRemove: (index: number) => void;
}

const TagItem: React.FC<TagItemProps> = ({ item, index, onRemove }) => {
  return (
    <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-sm">
      {item}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-4 w-4 p-0 hover:bg-gray-200 rounded-full"
        onClick={() => onRemove(index)}
      >
        <X className="size-3" />
      </Button>
    </span>
  );
};

export default TagItem;
